// Live directory data is loaded from the Genesis Rehab API (FindTreatment.gov).
export const DIRECTORY_IS_SAMPLE_DATA = false;

export const PROGRAM_TYPES = [
    { id: "all", label: "All Programs" },
    { id: "sober-living", label: "Sober Living" },
    { id: "rehab", label: "Rehab / Inpatient" },
    { id: "outpatient", label: "Outpatient" },
    { id: "resource", label: "Community Resource" },
];

export const US_STATES = [
    "All States",
    "California",
    "Colorado",
    "Florida",
    "Georgia",
    "Illinois",
    "Massachusetts",
    "Nevada",
    "North Carolina",
    "New York",
    "Ohio",
    "Oregon",
    "Tennessee",
    "Texas",
    "Washington",
];

export const getTypeLabel = (id) =>
    PROGRAM_TYPES.find((t) => t.id === id)?.label || "Program";
